import { Paper } from '@mui/material'
import { styled } from '@mui/material/styles'

export const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    // '&.MuiStack-root .MuiPaper-root .POSTBUTTONS .POSTBUTTON': {
    //     paddingLeft: '122px',
    // },

    // paddingLeft: huge === 't' ? '122px' : '0px',
    // textAlign: gglPostButton === '1' ? 'center' : 'left',
    // paddingLeft: gglPostButton === '1' ? '0px' : '22px',
    // color: theme.palette.text.secondary,
}))
